import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { productPropTypes } from 'helpers/propTypes';
import QuantitySelector from 'components/commons/QuantitySelector';
import BestPriceDisplay from 'components/commons/BestPriceDisplay';
import { formatCurrencyARS } from 'helpers/currency';
import { Link } from 'react-router-dom';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import './Item.scss';

const Item = (props) => {
  const {
    colors, combinations, combinationsTalle, item, onItemClick, onQuantityChange, quantity, talles,
    getValidPriceRange, show, client, isTextil = false, cantMedidasMax = 2, renderInstallmentsBadge,
    onBuyClick, autoDiscounts, paymentMethods,
  } = props;

  const unitPrice = item.sale > 0 ? item.sale : item.price;

  const [selectedColor, setSelectedColor] = useState(null);
  const [tallesXColor, setTallesXColor] = useState(null);
  const [intervalId, setIntervalId] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleColorSelect = (color, descriptions) => {
    setSelectedColor(color);
    setTallesXColor(descriptions);
  };

  const selectedColorImage = selectedColor
    ? (selectedColor.image_2 || selectedColor.image_1)
    : item.image1;
  const imageSource = selectedColor ? (selectedColorImage || item.image1) : item.image1;
  const hasNonNullPrice = talles.some(talle => talle.price !== null && talle?.price > 0);

  const colorsReducidos = colors.reduce((acc, obj) => {
    // Verificar si el valor de 'numero' ya está presente en el arreglo acumulador
    const exists = acc.some(
      ({ stock_description_id }) => stock_description_id === obj.stock_description_id,
    );
    // Si el valor de 'numero' no está repetido, agregamos el objeto al acumulador
    if (!exists) acc.push(obj);
    return acc;
  }, []);

  const handleMouseEnter = () => {
    let contador = -1;
    const id = setInterval(() => {
      if (contador < colorsReducidos.length && contador !== -1) {
        setSelectedColor(colorsReducidos[contador]);
        // eslint-disable-next-line no-plusplus
        contador++;
      } else {
        setSelectedColor(null);
        contador = 0;
      }
    }, 1500);
    setIntervalId(id);
  };

  const handleMouseLeave = () => {
    clearInterval(intervalId); // Detiene el intervalo
    setIntervalId(null); // Limpia el ID del intervalo
    setSelectedColor(null);
  };

  const onImageMouseEnter = () => {
    setIsHovered(true);         
  };
  const onImageMouseLeave = () => {
    setIsHovered(false);        
  };

  const dots = (word) => (word.length > 20 ? `${word.substring(0, 20)}...` : word);

  const renderProductButton = () => {
    if (item.product_wholesaler.length > 0) {
      return (
        <button type="button" onClick={onItemClick}>
          Ver Combos
        </button>
      );
    }

    if (item.stock_product_descriptions.length > 0) {
      return null;
    }

    if (item.stock > 0) {
      return (
        <div className={`product-quantity-selector${client && !!client.design ? '' : '-simple'}`}>
          <QuantitySelector
            limit={item.stock}
            onQuantityChange={onQuantityChange}
            quantity={quantity}
            show={show}
          />
        </div>
      );
    }

    return <span className="product-out-of-stock">Sin stock</span>;
  };

  const renderProductButtonSimple = () => {
    if (item.product_wholesaler.length > 0) {
      return (
        <div className="product-quantity-selector-simple">
          <button type="button" onClick={onItemClick}>
            Ver Combos
          </button>
        </div>
      );
    }

    if (item.stock_product_descriptions.length > 0) {
      return null;
    }

    if (item.stock > 0) {
      return (
        <div className="product-quantity-selector-simple">
          <QuantitySelector
            limit={item.stock}
            onQuantityChange={onQuantityChange}
            quantity={quantity}
            show={show}
          />
        </div>
      );
    }

    return <span className="product-out-of-stock">Sin stock</span>;
  };

  const renderBlankMeasureSpace = () => {
    const hasColors = colorsReducidos.length > 0;

    const tallesCount = tallesXColor?.length ?? (talles?.length ?? 0);
    const hasTalles = tallesCount > 0;
    const onlyColors = hasColors && !hasTalles;

    const baseRows = !onlyColors ? (Number(cantMedidasMax) || 0) + 1 : (Number(cantMedidasMax) || 0) + 1;
    const adjustedRows = Math.max(0, baseRows - (hasColors ? 1 : 0) - (hasTalles ? 1 : 0));
    if (adjustedRows === 0) return null;

    return (
      <div className="pt-price-table">
        {Array.from({ length: adjustedRows }).map((_, i) => (
          <div
          key={i}
          className={`pt-price-row ${onlyColors ? 'row-onlycolors' : ''}`}
          >
            <span className="pt-price-label">&nbsp;</span>
            <span className="pt-price-value"></span>
          </div>
        ))}
      </div>
    );
  };

  const handleBuy = (e) => {
    e.stopPropagation();
    (typeof onBuyClick === 'function' ? onBuyClick : onItemClick)();
  };

  if(client?.design === 3 ) {
    return(
      <div className="it-card">
        {item.sale > 0 && (
          <span className="it-badge">
            -{Math.round(100 - (item.sale / item.price) * 100)}% OFF
          </span>
        )}

        <div
          className="it-image"
          onClick={onItemClick}
          role="presentation"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <img src={imageSource} alt={item.name} />
          <span className="it-add">Ver Detalles</span>
        </div>

        <div className="it-body">
          <h3 className="it-title" onClick={onItemClick} role="presentation">
            {dots(item.name)}
          </h3>
          <div className="product-badges">
            {renderInstallmentsBadge()}
          </div>

          {colorsReducidos.length > 0 && (
            <div className="it-colors">
              {colorsReducidos.map((c) => {
                const isMulti = c?.stock_descriptions?.name === 'Multicolor';
                const bg = isMulti ? {} : { backgroundColor: c?.stock_descriptions?.rgb };
                const active = selectedColor?.stock_description_id === c.stock_description_id;
                return (
                  <span
                    key={`sw-${c.stock_description_id}`}
                    className={`it-swatch${active ? ' active' : ''}`}
                    style={bg}
                    role="presentation"
                    onClick={() => handleColorSelect(c)}
                  />
                );
              })}
              {colorsReducidos.length > 5 && <span className="it-more">+{colorsReducidos.length - 5}</span>}
            </div>
          )}

          <div className="it-sizes color-selector">
            {talles.length > 0 && <>Talles:&nbsp;</>}
            {!tallesXColor ? (
              Object.keys(combinationsTalle || {})?.map((id) => {
                const talle = talles.find(
                  ({ stock_description_id }) => stock_description_id === Number(id),
                );
                if (!talle) return null;
                return (
                  <span key={`talle-${talle.stock_description_id}`} className="it-size">
                    {talle.stock_descriptions?.name}
                  </span>
                );
              })
            ) : (
              tallesXColor.map((talle) => (
                <span key={`talle-${talle.stock_description_id}`} className="it-size">
                  {talle.stock_descriptions?.name}
                </span>
              ))
            )}
          </div>

          {Number(cantMedidasMax) > 0 && renderBlankMeasureSpace()}
          <div className="it-qty" />

          <button type="button" className="api-buy-btn" onClick={handleBuy}>
            Comprar
          </button>

          {client?.design !==3 &&
            <div className="it-total">
              <small>{quantity} × {formatCurrencyARS(item.sale || item.price)}</small>
              <strong>{formatCurrencyARS((item.sale || item.price) * quantity)}</strong>
            </div>
          }
          {/* <div className="it-actions">
            <Link to='/carrito' className="it-cart" onClick={(e) => { e.stopPropagation(); }}>
              <ShoppingCartIcon />
            </Link>
          </div> */}
        </div>
      </div>
    );
  }

  if (client?.design === 4) {
    const hasSale = Number(item.sale) > 0;
    const currentPrice = hasSale ? item.sale : item.price;
    const oldPrice = hasSale ? item.price : null;
  
    // categoría principal (si no hay, no se muestra)
    const categoryName = item?.categories?.[0]?.name;
  
    // “nuevo” opcional (si tenés otro flag, cambialo acá)
    const isNew = !!item.is_new || !!item.new;
  
    return (
      <div className="neo-card" data-testid={`product-${item.id}`}>
        {isNew && <span className="neo-badge">Nuevo</span>}
  
        {hasSale && <span className="itd5-badge">-{Math.round(100 - (item.sale / item.price) * 100)}%</span>}
        <div
          className="neo-img"
          onClick={onItemClick}
          role="presentation"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <img src={imageSource} alt={item.name} />
        </div>
  
        <div className="neo-body">
          {categoryName && <div className="neo-cat">{categoryName}</div>}
  
          <h3 className="neo-title" onClick={onItemClick} role="presentation">
            {dots(item.name)}
          </h3>
          <div className="product-badges">
            {renderInstallmentsBadge()}
          </div>
  
          <div className="neo-pricebox">
            <div className="neo-price">
              {formatCurrencyARS(currentPrice)}
            </div>
            {oldPrice ? (
              <div className="neo-old">
                {formatCurrencyARS(oldPrice)}
              </div>
            ) : null}
          </div>
          <BestPriceDisplay 
            unitPrice={unitPrice} 
            autoDiscounts={autoDiscounts} 
            paymentMethods={paymentMethods} 
            show={show}
            isItem={true}
          />

          <button type="button" className="api-buy-btn" onClick={handleBuy}>
            Comprar
          </button>
  
          {/* CTA opcional: si querés un botón */}
        </div>
      </div>
    );
  }
  
  
  return (
    <>
      { client && client.design === 2 && (
      <div className="card-sandy">
       <div className='img-sandy'>
         <img
           onClick={onItemClick}
           alt={item.name}
           src={imageSource}
           onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave}
           role="presentation"
         />
         <div onClick={onItemClick} className="buy-div-sandy">
           <span>VER PRODUCTO</span>
         </div>
       </div>
       <div className="card-info-sandy">
         {item.sale > 0
         && (
         <div className="discount-hight-light-sandy">
           <p className="flag-sandy discount-percent-sandy">{`- ${Math.round(100 - (item.sale / item.price) * 100)}% OFF `}</p>
         </div>
         )}
         <h2>{dots(item.name)}</h2>
         <div className="product-badges">
            {renderInstallmentsBadge()}
          </div>
       <div className="price-container-sandy">
           { !hasNonNullPrice ? (
             <>
             {item.sale > 0
               ? (
                 <>
                   <span className="price-sandy">
                     {formatCurrencyARS(item.sale)}
                   </span>
                   <span className="discount-sandy">{formatCurrencyARS(item.price)}</span>
                 </>
               )
               : <span className="price-sandy">{formatCurrencyARS(item.price)}</span>}
             </>
           ) : (
             <span className="price-sandy">{getValidPriceRange()}</span>
           ) }
          <BestPriceDisplay 
            unitPrice={unitPrice} 
            autoDiscounts={autoDiscounts} 
            paymentMethods={paymentMethods} 
            show={show} 
            isItem={true}
          />
         </div>

         <button type="button" className="api-buy-btn" onClick={handleBuy}>
           Comprar
         </button>
         {/* {Object.values(combinations).some(array => array.length > 0) && (
           <div className="color-selector-sandy">
             {Object.keys(combinations)?.map((id) => {
               const color = colors.find(({ stock_description_id }) => stock_description_id === Number(id));
               const descriptions = combinations[id];
               const isMulticolor = color.stock_descriptions.name === "Multicolor";
               return (
                 <div
                   key={id}
                   className={`color-circle-sandy ${isMulticolor ? 'multicolor-sandy' : ''} ${selectedColor?.id === color.id ? 'selected-sandy' : ''}`}
                   style={isMulticolor ? {} : { backgroundColor: color.stock_descriptions.rgb }}
                   onClick={() => handleColorSelect(color, descriptions)}
                 />
               );
             })}
           </div>
         )}
         
         <div className="color-selector-sandy">
           { talles.length > 0 && (
           <>
             Talles:&nbsp;
           </>
           )}
           { !tallesXColor ? (Object.keys(combinationsTalle)?.map((id) => {
             const talle = talles.find(({ stock_description_id }) => stock_description_id === Number(id));
             return (
               <span>{talle.stock_descriptions.name}</span>
             );
           })) : (
             tallesXColor.map((talle) =>               
               <span>{talle.stock_descriptions.name}</span>
             )
           )}
         </div> */}
       </div>
     </div>
 
      )}
    
      { client && client.design !==2 && (
       !!client.design ?
      <div className="product-item-sandy" data-testid={`product-${item.id}`}>
        <div className="product">
          <div className="product-image" onMouseEnter={() => handleMouseEnter()} onMouseLeave={() => handleMouseLeave()}>
            <div className="product-image-icons">
              <img src={imageSource} alt={item.name} onClick={onItemClick} role="presentation" />
              {renderProductButton()}
            </div>
          </div>
          <div className="product-info">
            <h5 className="product-name" style={{ margin: 0 }} onClick={onItemClick} role="presentation">
              {window.innerWidth < 576 && item.name.length > 25 ? `${item.name.slice(0, 23)}...`: item.name}
              <div className="product-badges">
                {renderInstallmentsBadge()}
              </div>
              <div className="product-price">
                <>
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {item.product_wholesaler.length > 0 > 0 ? (<span style={{ color: 'black' }}>Combos Disponibles!</span>) : item.sale ? <div style={{ color: 'red' }}>{` ${Math.round(100 - (item.sale / item.price) * 100)}% OFF `}</div> : <br />}
                  <div className="row" style={{ justifyContent: 'space-between', margin: 0}}>
                    <span style={{ color: 'black' }}>{item ? item.categories[0].name : <></>}</span>
                    {show && formatCurrencyARS(item.sale || item.price)}
                  </div>
                </>
              </div>
              <div className='best-price'>
                <BestPriceDisplay 
                  unitPrice={unitPrice} 
                  autoDiscounts={autoDiscounts} 
                  paymentMethods={paymentMethods} 
                  show={show}
                  isItem={true}
                />
              </div>
            </h5>
            <button type="button" className="api-buy-btn" onClick={handleBuy}>
              Comprar
            </button>
            {Object.values(combinations).some((array) => array.length > 0) && (
              <div className="color-selector">
                {Object.keys(combinations).map((id) => {
                  const color = colors.find(
                    ({ stock_description_id }) => stock_description_id === Number(id),
                  );
                  const descriptions = combinations[id];
                  const isMulticolor = color.stock_descriptions.name === 'Multicolor';
                  return (
                    <div
                      className={`color-circle ${isMulticolor ? 'multicolor' : ''}`}
                      key={id}
                      onClick={() => handleColorSelect(color, descriptions)}
                      role="presentation"
                      style={isMulticolor ? {} : { backgroundColor: color.stock_descriptions.rgb }}
                    />
                  );
                })}
              </div>
            )}
            <div className="color-selector">
              {talles.length > 0 && <>Talles:&nbsp;</>}
              {!tallesXColor ? (Object.keys(combinationsTalle)?.map((id) => {
                const talle = talles.find(
                  ({ stock_description_id }) => stock_description_id === Number(id),
                );
                return (
                  <span key={`talle-${talle.stock_description_id}`}>{talle.stock_descriptions.name}</span>
                );
              })) : (
                tallesXColor.map((talle) => <span key={`talle-${talle.stock_description_id}`}>{talle.stock_descriptions.name}</span>)
              )}
            </div>
          </div>
        </div>
      </div>
      :
      <div className="product-item" data-testid={`product-${item.id}`}>
        <div className="product-simple">
          <div className="product-image-simple" onClick={onItemClick} role="presentation">
            <img src={item.image1} alt={item.name} />
          </div>
          <div className="product-info-simple">
            <h6 className="product-name-simple" onClick={onItemClick} role="presentation">
              {item.name}
              <div className="product-badges">
                {renderInstallmentsBadge()}
              </div>
              <div className="product-price-simple price-text">
                {item.product_wholesaler.length > 0 > 0
                  ? (
                    <div className="price-item-mayorista" />
                  )
                  : (
                    <>
                      {item.sale ? <div style={{ color: 'red' }}>{` ${Math.round(100 - (item.sale / item.price) * 100)}% OFF `}</div> : <div />}
                      <br />
                      {formatCurrencyARS(item.sale || item.price)}
                      {!!item.sale && <span data-testid="product-on-sale">{formatCurrencyARS(item.price)}</span>}
                    </>
                  )}
              </div>
            </h6>
            <BestPriceDisplay 
              unitPrice={unitPrice} 
              autoDiscounts={autoDiscounts} 
              paymentMethods={paymentMethods} 
              show={show}
              isItem={true}
            />
            <button type="button" className="api-buy-btn" onClick={handleBuy}>
              Comprar
            </button>
            {renderProductButtonSimple()}
          </div>
        </div>
      </div>
    )}
    </>
  );
};

Item.defaultProps = {
  combinations: {},
  combinationsTalle: {},
};

Item.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  combinations: PropTypes.shape(),
  combinationsTalle: PropTypes.shape(),
  item: productPropTypes.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onBuyClick: PropTypes.func,
  onQuantityChange: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
  talles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default Item;
